module.exports = __webpack_public_path__ + "static/media/YM77_2.2a907e57.jpg";